export function identity<T>(v: T): T {
  return v;
}
